import React from 'react';
import { FileModel } from 'services/EpdClient';
import FilesList from 'components/v2/file-row/FilesList';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useVersionLogContext } from '../hooks/useVersionLogContext';
import { VersionLogFilesListRecord } from '../records/VersionLogFilesListRecord';

const FilesListRenderer: React.FC<VersionLogFilesListRecord> = ({ label, propertyId }) => {
  const { data } = useVersionLogContext();
  const raw = data?.[propertyId];
  const files = (Array.isArray(raw) ? raw : []) as FileModel[];

  if (files.length === 0) {
    return null;
  }

  return (
    <div>
      <SmartLabel label={label} />
      <FilesList files={files} disabled />
    </div>
  );
};

export default FilesListRenderer;
